import {FC, memo, useCallback, useMemo, useState} from 'react';
import {Colors, HintTooltip, useBreakpoint, useToasts} from "@brg/ui";
import { copyLinkProject } from "../../helpers/copyLink";
import { IconWrapper } from 'shared/assets/styles';
import { Project } from '@brg/api';
import { ShareButtonWrapper } from './styles';
import {LayoutConst, useModal} from "../../../core";
import {SP_VOTE_COLLECTION_SIGN} from "../../pages/VotesAdmin/VotesAdminPage";
import {useTranslation} from "react-i18next";
import {useTheme} from "styled-components";
import { ShareIcon } from 'shared/icons/projectToolsWithResize/ShareIcon';

interface ShareButtonProps {
  project: Project;
  showLikeDropdown?: boolean;
  setMobileOffset?: (val: number) => void;
  inActiveState?: boolean;
}

const ShareButton: FC<ShareButtonProps> = ({ project, showLikeDropdown, inActiveState, setMobileOffset }) => {
  const toasts = useToasts();
  const modal = useModal();
  const [childEntities, setChildEntities] = useState(project?.childEntities);
    const isCollectionVote = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)), [project])
    const { t } = useTranslation();
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const theme = useTheme();
    const onWhiteBg = theme.app.backgroundColor === Colors.gal

  const handleClick = useCallback(() => {
    if(inActiveState) return null;
    
    copyLinkProject(project?.projectId, toasts, t)
  }, [project, toasts, inActiveState, t]);

  if (showLikeDropdown) {
    return (
      <ShareButtonWrapper className="ShareButtonWrapper ps-action-btn">
          <IconWrapper onClick={inActiveState ? () => false : () => modal.show('share', {
              isBook: project?.book,
              project: project,
              projectId: project?.projectId,
              projectStatus: project?.status,
              childEntities: childEntities,
              setChildEntities: setChildEntities,
              title: project?.title,
              images: project?.titleImages
          })}>
              <HintTooltip
              text={t(isCollectionVote ? "sharing.title_voting" : "hints.share")}
              z={8}
              positionY={is744 ? "bottom" : "default"}
              customStyle={
                isCollectionVote
                  && {
                    background: "#464645", backgroundColor: "#464645"
                  }
              }
              isPermanent={isCollectionVote}
              setMobileHeight={setMobileOffset}
              onWhiteBg={onWhiteBg}
            >
              <ShareIcon />
            </HintTooltip>
          </IconWrapper>
    </ShareButtonWrapper>
    )
  }

  return (
    <IconWrapper onClick={handleClick}>
            <ShareIcon/>

    </IconWrapper>
  )
};

export default memo(ShareButton)

import {FC, memo, useCallback, useMemo, useState} from 'react';
import {Colors, HintTooltip, useBreakpoint, useToasts} from "@brg/ui";
import { copyLinkProject } from "../../helpers/copyLink";
import { IconWrapper } from 'shared/assets/styles';
import { Project } from '@brg/api';
import { ShareButtonWrapper } from './styles';
import {LayoutConst, useModal} from "../../../core";
import {SP_VOTE_COLLECTION_SIGN} from "../../pages/VotesAdmin/VotesAdminPage";
import {useTranslation} from "react-i18next";
import {useTheme} from "styled-components";
import { ShareIcon } from 'shared/icons/projectToolsWithResize/ShareIcon';

interface ShareButtonProps {
  project: Project;
  showLikeDropdown?: boolean;
  setMobileOffset?: (val: number) => void;
  inActiveState?: boolean;
}

const ShareButton: FC<ShareButtonProps> = ({ project, showLikeDropdown, inActiveState, setMobileOffset }) => {
  const toasts = useToasts();
  const modal = useModal();
  const [childEntities, setChildEntities] = useState(project?.childEntities);
    const isCollectionVote = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)), [project])
    const { t } = useTranslation();
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const theme = useTheme();
    const onWhiteBg = theme.app.backgroundColor === Colors.gal

  const handleClick = useCallback(() => {
    if(inActiveState) return null;
    
    copyLinkProject(project?.projectId, toasts, t)
  }, [project, toasts, inActiveState, t]);

  if (showLikeDropdown) {
    return (
      <ShareButtonWrapper className="ShareButtonWrapper ps-action-btn">
          <IconWrapper onClick={inActiveState ? () => false : () => modal.show('share', {
              isBook: project?.book,
              project: project,
              projectId: project?.projectId,
              projectStatus: project?.status,
              childEntities: childEntities,
              setChildEntities: setChildEntities,
              title: project?.title,
              images: project?.titleImages
          })}>
              <HintTooltip
              text={t(isCollectionVote ? "sharing.title_voting" : "hints.share")}
              z={8}
              positionY={is744 ? "bottom" : "default"}
              customStyle={
                isCollectionVote
                  && {
                    background: "#464645", backgroundColor: "#464645"
                  }
              }
              isPermanent={isCollectionVote}
              setMobileHeight={setMobileOffset}
              onWhiteBg={onWhiteBg}
            >
              <ShareIcon />
            </HintTooltip>
          </IconWrapper>
    </ShareButtonWrapper>
    )
  }

  return (
    <IconWrapper onClick={handleClick}>
            <ShareIcon/>

    </IconWrapper>
  )
};

export default memo(ShareButton)

